module.exports = __webpack_public_path__ + "img/list-timeline.b4b234aa.svg";